import { jsx } from "react/jsx-runtime";
import { LoadingButton } from "@zillow/constellation";
import PropTypes from "prop-types";
import "react";
import { useFormState } from "react-hook-form";
const ApexSubmit = ({
  children,
  ...rest
}) => {
  const formStateProxy = useFormState();
  const formState = {
    isSubmitting: formStateProxy.isSubmitting
  };
  return /* @__PURE__ */ jsx(LoadingButton, { type: "submit", ...rest, disabled: formState.isSubmitting, loading: formState.isSubmitting, children });
};
ApexSubmit.propTypes = {
  children: PropTypes.node.isRequired
};
ApexSubmit.defaultProps = {};
export {
  ApexSubmit as default
};
